import React from 'react'
import toast from 'react-hot-toast'
import { BlockWrapper, defineBlock } from '@smartfire/js-block-engine'
import {retrieveExtId} from "../types";
import { useFavoriteCompetitions } from '../../hooks/competitions'
import {
    DEFAULT_PARAMS,
    keepOnlyParams,
    Params,
    useParamsHandler
} from "../../hooks/useCompetitionProps/useParamsHandler";
import { RectangularButton } from '../RectangularButton'
import styles from './styles.module.scss'

const FavoriteButton = (attributes) => {
    const {favoritesPoules, addFavorite, removeFavorite} = useFavoriteCompetitions()
    const [params] = useParamsHandler<Params>({
        initParams: {
            ...DEFAULT_PARAMS,
            ...keepOnlyParams(attributes),
        }
    })

    const extPouleId = Number(params.ext_poule_id)
    const extCompetitionId = retrieveExtId(params.url_competition)
    const isEquipeMode = Boolean(params.ext_equipe_id)


    const isFavorite = favoritesPoules.some(({extPouleId: localExtPouleId}) => localExtPouleId === extPouleId)

    const handleClick = () => {
        if (isFavorite) {
            removeFavorite({extPouleId, extCompetitionId})
        } else {
            addFavorite({extPouleId, extCompetitionId})
        }

        toast.success(
            <span className={styles.toast}>
                {isFavorite ? 'Supprimé des favoris' : 'Ajouté aux favoris'}
            </span>,
            {
                position: 'bottom-center',
            },
        )
    }

    return (
        <RectangularButton
            flatIcon="heart"
            onClick={handleClick}
            color={isFavorite ? 'lightgrey' : 'primary'}
            disabled={isEquipeMode}
        >
            {isFavorite ? 'Supprimer de mes favoris' : 'Ajouter à mes favoris'}
        </RectangularButton>
    )
}

const FavoriteButtonBlock = (attributes) => (
    <BlockWrapper.Without>
        <FavoriteButton {...attributes} />
    </BlockWrapper.Without>
)

export default defineBlock({
    Block: FavoriteButtonBlock,
})
